import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ResourceTypes } from '../../constants/resource-types.enum';

@Component({
    selector: 'app-modal-content',
    templateUrl: './modal-content.component.html',
    styleUrls: ['./modal-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalContentComponent implements OnInit{
  @Input() type!: ResourceTypes | null;
  @Input() resource!: string | null;

  resourceType = ResourceTypes;

  loading = true;

  ngOnInit(): void {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
}
